import Vue from 'vue';
import useVueCompositionApi from '@/js/common/plugins/use-vue-composition-api';
import GiftCertificatesBanner from './GiftCertificatesBanner.vue';

useVueCompositionApi();

function initGiftCertificatesBanner() {
    const containers = document.querySelectorAll('.js-gift-certificates-banner');

    containers.forEach(container => {
        if (container && !container.__vueInstance) {
            container.__vueInstance = new Vue({
                render: (h) => h(GiftCertificatesBanner, {
                    props: {
                        link: container?.dataset?.link || '/certificates',
                    },
                }),
            }).$mount(container);
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftCertificatesBanner);
} else {
    initGiftCertificatesBanner();
}

export default initGiftCertificatesBanner;


